module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.library.js
 ** module id = 41
 ** module chunks = 0
 **/